import * as React from 'react';
export const TOSvg = React.forwardRef(function TOSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#B1372F',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M2 0h5v7H0V2a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B1372F',
        fillRule: 'nonzero',
        d: 'M3 3V2h1v1h1v1H4v1H3V4H2V3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M7 0v1H2a1 1 0 0 0-1 1v5H0V2a2 2 0 0 1 2-2h5Z',
      }),
    ),
  );
});
TOSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TO = {
  category: 'flag',
  colorable: false,
  name: 'TO',
  svg: TOSvg,
};
